import React, { useState, useRef, useCallback } from "react";

export const CompareSlider = ({
  firstImage = "",
  secondImage = "",
  initialSliderPercentage = 50,
}) => {
  const [sliderPercentage, setSliderPercentage] = useState(
    initialSliderPercentage
  );
  const sliderRef = useRef(null);

  const handleMouseMove = useCallback((e) => {
    if (!sliderRef.current) return;

    const rect = sliderRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percent = Math.min(Math.max((x / rect.width) * 100, 0), 100);
    setSliderPercentage(percent);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!sliderRef.current) return;

    const rect = sliderRef.current.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const percent = Math.min(Math.max((x / rect.width) * 100, 0), 100);
    setSliderPercentage(percent);
  }, []);

  return (
    <div
      ref={sliderRef}
      className="compare-slider"
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
    >
      {/* First Image */}
      <div
        className="image-container first-image"
        style={{ clipPath: `inset(0 ${100 - sliderPercentage}% 0 0)` }}
      >
        <img src={firstImage} alt="First Image" className="compare-image " />
      </div>

      {/* Second Image */}
      <div className="image-container">
        <img src={secondImage} alt="Second Image" className="compare-image " />
      </div>

      {/* Handlebar */}
      <div
        className="slider-handlebar"
        style={{ left: `${sliderPercentage}%` }}
      >
        <div className="handle-dot" />
      </div>
    </div>
  );
};

export default CompareSlider;
